import { doc, setDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Typography, Button, Box, Container } from '@mui/material';
import backgroundImage from '../assets/bg.jpg';
import './LandingPage.css';
import TemporaryDrawer from "../components/drawer";

function About() {
  const navigate = useNavigate();

  // Fade in effects
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Generate unique string
  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Generate room with unique link
  const handleCreateRoom = async () => {
    const UUID = generateUUID();
    await setDoc(doc(db, "rooms", UUID), {
      messages: []
    })
    navigate('/chat/'+UUID);
  }

  return (
    <Container
      sx={{
        minWidth: '100vw',
        minHeight: '100vh',
        overflow: 'hidden',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: -1
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',  // Center the box vertically
          textAlign: 'center',        // Center the text
          height: 'auto',
          width: '80%',               // Adjust width as needed
          maxWidth: '600px',          // Optional max width
        }}
      >
        <Typography
          variant="h5"
          className="header"
          sx={{
            mb: 4,
            color: 'white',
            opacity: visible ? 1 : 0,
            transition: 'opacity 1s 0.3s',
            fontSize: '1.25rem', // Adjust font size as needed
          }}
        >
          We offer a seamless, anonymous chat experience accessible anytime without the need for login. It’s a safe space where you can seek support, advice, or simply connect when you need to. You have full control over your conversations, ensuring your privacy and anonymity are always maintained. Our approach is completely unbiased, providing a non-judgmental environment where you can share openly and feel truly heard.           
        </Typography>
        <Button
          variant="outlined"
          size="large"
          className="header"
          sx={{
            opacity: visible ? 1 : 0,
            transform: `translateY(${visible ? 0 : '1rem'})`,
            transition: 'opacity 1s 0.6s, transform 1s 0.5s',
            borderColor: 'white',
            textTransform: 'none',
            borderRadius: '20px',
            color: 'white',
            fontWeight: 'bold',
            padding: '10px 20px',
            '&:hover': {
              transition: '0.5s',
              color: 'white', 
              borderColor: 'white',
              transform: 'scale(1.05)',
              backgroundColor: 'transparent',
            },
          }}
          onClick={handleCreateRoom}
        >
          Chat to us now
        </Button>
      </Box>
      <TemporaryDrawer></TemporaryDrawer>
    </Container>
  );
};

export default About;
